import { lazy } from 'react';
import 'react-native-gesture-handler';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import { ChatPageProps } from './components/ChatPageContent';

const ChatPageContent = lazy(() => import('./components/ChatPageContent'));

export const ChatPage = wrapLazyNavigatorScreen(
  (props: ChatPageProps) => {
    return <ChatPageContent {...props} />;
  },
  { headerShown: false },
);
